const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20illustration%2C%20dramatic%20scene%20of%20couple%20in%20elegant%20mansion%20setting%2C%20warm%20amber%20lighting%20from%20chandelier%2C%20emotional%20atmosphere%2C%20rich%20details%2C%20modern%20webtoon%20art%20style%2C%20clean%20composition&width=1200&height=600&seq=carousel-manga-01&orientation=landscape',
    tag: '韩漫专题',
    tagColor: 'bg-accent-100/90 text-accent-800',
    title: '豪门恩怨：五部不容错过的韩漫豪门题材',
    desc: '从《秘密教学》到《再婚皇后》，豪门题材韩漫以其精致的画风和跌宕的剧情俘获了大批读者。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20action%20manga%20illustration%2C%20epic%20supernatural%20battle%20scene%20in%20urban%20setting%2C%20dynamic%20energy%20explosions%2C%20warm%20orange%20and%20crimson%20accents%2C%20dark%20atmosphere%2C%20modern%20anime%20art%20style&width=1200&height=600&seq=carousel-manga-02&orientation=landscape',
    tag: '日漫专题',
    tagColor: 'bg-primary-100/90 text-primary-800',
    title: '热血不灭：日漫战斗番终极推荐指南',
    desc: '从经典到新番，为你盘点那些让人热血沸腾的日漫战斗佳作，每一拳都打在心上。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20illustration%2C%20ancient%20Chinese%20warrior%20in%20flowing%20robes%20with%20spiritual%20energy%2C%20mountain%20landscape%20background%2C%20golden%20and%20jade%20tones%2C%20epic%20atmosphere%2C%20modern%20Chinese%20comic%20style&width=1200&height=600&seq=carousel-manga-03&orientation=landscape',
    tag: '国漫专题',
    tagColor: 'bg-secondary-100/90 text-secondary-800',
    title: '国漫崛起之路：从模仿到创新的十年蜕变',
    desc: '国漫产业经历了从量变到质变的飞跃，如今已涌现出大量质量上乘、风格独特的优秀作品。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20webtoon%20illustration%2C%20magical%20reincarnation%20theme%20with%20castle%20and%20royal%20characters%2C%20soft%20pastel%20and%20gold%20accents%2C%20dreamy%20atmosphere%2C%20modern%20manhwa%20art%20style%2C%20elegant%20composition&width=1200&height=600&seq=carousel-manga-04&orientation=landscape',
    tag: '韩漫专题',
    tagColor: 'bg-accent-100/90 text-accent-800',
    title: '重生逆袭：韩漫异世界转生题材大赏',
    desc: '转生异世界、重生复仇、穿越古代——韩漫中最受欢迎的题材之一，每一部都让人欲罢不能。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20slice%20of%20life%20manga%20illustration%2C%20cozy%20school%20club%20activities%20scene%2C%20group%20of%20friends%20in%20classroom%20with%20sunlight%2C%20warm%20and%20nostalgic%20atmosphere%2C%20soft%20colors%2C%20modern%20anime%20art%20style&width=1200&height=600&seq=carousel-manga-05&orientation=landscape',
    tag: '日漫专题',
    tagColor: 'bg-primary-100/90 text-primary-800',
    title: '治愈时光：最适合放松心情的日漫日常番',
    desc: '不需要激烈的战斗和复杂的剧情，简单温暖的日常漫画同样能带来满满的治愈感。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">深度漫画专题，发现更多精彩</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.slice(0, 2).map((item, i) => (
            <div key={i} className="lg:col-span-1 bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="h-48 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium mb-2 ${item.tagColor}`}>
                  {item.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          {carouselItems.slice(2).map((item, i) => (
            <div key={i + 2} className="lg:col-span-1 bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="h-48 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium mb-2 ${item.tagColor}`}>
                  {item.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}